<template>
  <vl-layer-image
    :extent="imageExtent"
    :opacity="0"
  >
    <vl-source-raster
      v-if="baseSource && ongoingHistogramExtraction"
      :sources="[baseSource]"
      :operation="pixelObserver"
      :lib="operationLib"
      @beforeoperations="beforeOperations"
      @afteroperations="afterOperations"
    />
  </vl-layer-image>
</template>

<script>

import {emptyHistogram} from "@/utils/histogram-utils";

/**
 * Run calculations on pixel data.
 * @param {Array} pixels List of pixels (one per source). There is at least one, and only the first is considered.
 * @param {Object} data User data object.
 * @return {Array} The output pixel.
 */
function pixelObserverFunc(pixels, data) {
  const pixel = pixels[0];
  appendToHistogram(pixel, data.histogram)
  data.pixelCount++;
  return pixel;
}

/**
 * Append pixel value in the histogram
 * @param {Array} pixel
 * @param {Array} histogram
 */
function appendToHistogramFunc(pixel, histogram) {
  // Image is expected to be grayscale
  histogram[pixel[0]]++;
}

/**
 * This component is used to compute current extent histogram on greyscale image.
 * The component layer has to be visible for OpenLayers to work with
 * but must not be displayed in the viewer (opacity = 0).
 */
export default {
  name: 'histolog-histogram-extractor',
  props: {
    index: String,
    baseSource: Object
  },
  data() {
    return {
      revision: 0,

      lastResolution: null,
      lastExtent: null,
    };
  },
  computed: {
    imageModule() {
      return this.$store.getters['currentProject/imageModule'](this.index);
    },
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    image() {
      return this.imageWrapper.imageInstance;
    },
    ongoingHistogramExtraction() {
      return this.imageWrapper.colorOverlay.ongoingHistogramExtraction;
    },
    imageExtent() {
      return [0, 0, this.image.width, this.image.height];
    },
    pixelObserver() {
      return pixelObserverFunc;
    },
    operationLib() {
      return  {
        appendToHistogram: appendToHistogramFunc
      }
    },
  },
  methods: {
    afterOperations(event) {
      if (event.data.revision < this.revision) {
        console.warn(`Histogram extraction rev ${event.data.revision} while waiting for ${this.revision}`);
        return;
      }
      this.$store.dispatch(this.imageModule + 'endHistogramExtraction', {
        histogram: event.data.histogram,
        pixelCount: event.data.pixelCount / event.resolution
      });

      this.lastResolution = event.resolution;
      this.lastExtent = event.extent;
      this.revision++;
    },
    beforeOperations(event) {
      event.data.histogram = emptyHistogram();
      event.data.pixelCount = 0;
      event.data.revision = this.revision;
    }
  },
};
</script>
